/** @jsxImportSource @emotion/react */
import React, { FC, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SearchIcon from '@mui/icons-material/Search';
import {
  Button,
  css,
  InputAdornment,
  Stack,
  TextField,
  useTheme,
} from '@mui/material';
import Header from 'components/Header';
import { useTelegramUser } from 'hooks/useTelegramUser';
import { TXT_BACK, TXT_SEARCH } from 'translations';
import { ROUTES } from 'utils/routes';
import { Props } from './types';

const MenuSearch: FC<Props> = ({ search, setSearch }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [hide, setHide] = useState(true);
  const handleHide = (value: boolean) => () => setHide(value);
  const { id: userId } = useTelegramUser();

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  return (
    <>
      <Header hide={hide}>
        <Stack spacing={2} direction="row">
          <Button
            component={Link}
            to={generatePath(ROUTES.WEEK, { userId: `${userId}` })}
            variant="contained"
            startIcon={<ArrowBackIosNewIcon />}
          >
            {t(TXT_BACK)}
          </Button>

          <TextField
            onFocus={handleHide(false)}
            onBlur={handleHide(true)}
            fullWidth
            variant="outlined"
            size="small"
            value={search}
            placeholder={t(TXT_SEARCH)}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    css={css`
                      color: ${theme.palette.primary.main};
                    `}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
      </Header>
    </>
  );
};

export default memo(MenuSearch);
